/* Varukorgslådan (snippets/NV-CART-DRAWER.liquid): öppna, stänga, antal, kommentar och tillägg. */
(function () {
  var drawer   = document.getElementById('nv-cart-drawer');
  var overlay  = document.getElementById('nv-cart-drawer-overlay');
  var closeBtn = document.getElementById('nv-cart-drawer-close');
  var inner    = document.getElementById('nv-cart-drawer-inner');
  var titleEl  = document.getElementById('nv-cart-drawer-title');
  var topCheckout = document.getElementById('nv-cart-drawer-checkout');
  var msgEl    = document.getElementById('nv-cart-drawer-msg');
  var isCartPage = /\/cart\/?$/.test(window.location.pathname);
  var lastFocus = null;
  var SECTION = 'nv-cart-drawer-content';

  // Egen referens till fetch, tagen innan patchen längre ner. Lådans egna
  // anrop (och offerten, via NVCartDrawer.fetch) ska inte trigga patchen.
  var nativeFetch = window.fetch.bind(window);

  /* ---- Open / close ---- */
  function isOpen() { return drawer.classList.contains('nvd-open'); }
  function open() {
    NVPanel.opening('cart');
    if (!isOpen()) lastFocus = document.activeElement;
    drawer.classList.add('nvd-open');
    overlay.classList.add('nvd-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.classList.add('nvd-drawer-open');
    closeBtn.focus();
  }
  function close() {
    drawer.classList.remove('nvd-open');
    overlay.classList.remove('nvd-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('nvd-drawer-open');
    hideMessage();
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  /* ---- Meddelanden (fel, lagergräns): ligger kvar tills nästa antalsändring eller tills lådan stängs ---- */
  function showMessage(text) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.hidden = false;
  }
  function hideMessage() {
    if (!msgEl) return;
    msgEl.hidden = true;
    msgEl.textContent = '';
  }
  function errorText(data, fallback) {
    if (data && typeof data.description === 'string' && data.description) return data.description;
    if (data && typeof data.message === 'string' && data.message) return data.message;
    return fallback;
  }
  function lineName(line) {
    var v = line.variant_title;
    return line.product_title + (v && v !== 'Default Title' ? ' (' + v + ')' : '');
  }

  /* ---- Räknaren på varukorgsikonen i headern ---- */
  function updateHeaderCount(count) {
    count = parseInt(count, 10) || 0;
    var els = document.querySelectorAll('[data-header-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-header-cart-count', count > 0 ? String(count) : '');
      els[i].classList.toggle('visible', count > 0);
    }
    // Länkens namn börjar med den synliga etiketten "Varukorg", följt av antalet
    var links = document.querySelectorAll('[data-nv-cart-link]');
    for (var j = 0; j < links.length; j++) {
      links[j].setAttribute('aria-label', 'Varukorg' + (count === 1 ? ', 1 vara' : count > 1 ? ', ' + count + ' varor' : ''));
    }
  }

  /* Antal varor enligt räknaren i headern (0 om okänt) */
  function currentCount() {
    var el = document.querySelector('[data-header-cart-count]');
    return el ? (parseInt(el.getAttribute('data-header-cart-count'), 10) || 0) : 0;
  }

  /* ---- Rubrik eller kassaknapp överst ---- */
  function updateTop(count) {
    var hasItems = count > 0;
    if (topCheckout) topCheckout.hidden = !hasItems;
    if (titleEl) {
      titleEl.hidden = hasItems;
      titleEl.textContent = 'Varukorg';
    }
  }

  /* ---- Lådans innehåll ----
     Ritas från sektionen nv-cart-drawer-content: antingen hämtad med Section
     Rendering API, eller som kom med svaret från change.js/add.js (sections). */
  function applyHtml(html) {
    // Behåll det kunden håller på att skriva i kommentarsfältet
    var noteEl = inner.querySelector('[data-nv-cart-note]');
    var noteFocused = noteEl && document.activeElement === noteEl;
    var noteValue = noteEl ? noteEl.value : null;
    var caret = noteFocused ? noteEl.selectionStart : null;
    var scrollTop = inner.scrollTop;

    // Kom ihåg vilken knapp som hade fokus (+, − eller papperskorgen på vilken rad)
    var active = document.activeElement;
    var focusKey = '', focusSel = '';
    if (active && inner.contains(active) && active.getAttribute('data-item-key')) {
      focusKey = active.getAttribute('data-item-key');
      if (active.classList.contains('nvd-item-remove')) focusSel = '.nvd-item-remove';
      else if (active.classList.contains('nvd-qty-btn')) focusSel = '.nvd-qty-btn[data-delta="' + active.getAttribute('data-delta') + '"]';
    }

    inner.innerHTML = html;
    if (window.NVConfirm && window.NVConfirm.check) window.NVConfirm.check();
    // Radbeloppen följer valet exkl./inkl. moms (snippets/NV-MOMS.liquid)
    if (window.NVMoms) window.NVMoms.render(inner);
    inner.scrollTop = scrollTop;

    var newNote = inner.querySelector('[data-nv-cart-note]');
    if (newNote && noteValue !== null && (noteFocused || NVCartNote.pending())) {
      newNote.value = noteValue;
      if (noteFocused) {
        newNote.focus();
        try { newNote.setSelectionRange(caret, caret); } catch (err) {}
      }
    }

    if (focusKey && focusSel) {
      var rows = inner.querySelectorAll('.nvd-item');
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].getAttribute('data-item-key') !== focusKey) continue;
        var target = rows[i].querySelector(focusSel);
        if (target) target.focus({ preventScroll: true });
        break;
      }
    }

    var countEl = inner.querySelector('[data-nv-cart-count]');
    var count = countEl ? (parseInt(countEl.getAttribute('data-nv-cart-count'), 10) || 0) : currentCount();
    updateTop(count);
    updateHeaderCount(count);
  }

  /* ---- Section Rendering API ----
     Uppdateringar köas i stället för att tappas: kommer en ny begäran medan
     en redan pågår körs en till direkt efteråt, så att lådan alltid visar
     det senaste läget. */
  var refreshRunning = false;
  var refreshQueued = false;

  function refresh() {
    if (refreshRunning) { refreshQueued = true; return; }
    refreshRunning = true;
    refreshQueued = false;

    // Visa "Laddar…" bara när lådan är tom. Annars ligger innehållet kvar
    // tills det nya kommer, så att det inte blinkar eller hoppar.
    if (!inner.firstElementChild) {
      inner.innerHTML = '<div class="nvd-loading">Laddar…</div>';
    }

    nativeFetch('/?sections=' + SECTION, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var html = data && data[SECTION];
        if (typeof html !== 'string') throw new Error('Saknar sektionen');
        // Har kunden hunnit ändra ett antal medan svaret var på väg: rita inte
        // om med gamla siffror, en ny uppdatering körs när ändringen är sparad.
        if (qtyBusy()) { refreshQueued = true; return; }
        applyHtml(html);
      })
      .catch(function () {
        // Det som redan visas ligger kvar (även kommentaren kunden skriver)
        if (inner.querySelector('.nvd-item, .nvd-empty')) {
          showMessage('Varukorgen kunde inte uppdateras just nu. Försök igen om en stund.');
        } else {
          inner.innerHTML = '<p style="padding:24px 0;text-align:center;color:#000000;">Något gick fel. <a href="/cart">Öppna varukorgen</a></p>';
        }
      })
      .then(function () {
        refreshRunning = false;
        if (refreshQueued && !qtyBusy()) refresh();
        else if (!qtyBusy()) drawer.classList.remove('nvd-stale');
      });
  }

  function openAndRefresh() {
    if (isCartPage) return;
    if (currentCount() > 0) updateTop(currentCount());
    refresh();
    open();
  }

  /* ---- Close triggers ---- */
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  /* Escape stänger, Tab stannar i lådan: NVPanel (snippets/NV-PANEL-CORE.liquid) */
  NVPanel.keys(function () { return isOpen() ? drawer : null; }, close);
  NVPanel.register('cart', isOpen, close);

  function confirmRemove(el) {
    var msg = 'Ta bort?';
    return window.NVConfirm
      ? window.NVConfirm(el, msg, 'Ta bort')
      : Promise.resolve(window.confirm(msg));
  }

  /* ---- Antal: siffran ändras direkt, sparas efter en kort paus ----
     Varje rad har ett önskat antal. Snabba tryck samlas ihop till ett enda
     anrop, och ändras antalet medan ett anrop pågår skickas ett till efteråt.
     Svaret från change.js har med lådans nya innehåll (sections), så ingen
     extra hämtning behövs när allt är sparat. */
  var qtyState = {};
  var qtyFailed = false;

  function qtyBusy() {
    for (var k in qtyState) {
      if (qtyState.hasOwnProperty(k) && (qtyState[k].timer || qtyState[k].inflight)) return true;
    }
    return false;
  }

  function setQty(key, qty, immediate) {
    var st = qtyState[key] || (qtyState[key] = { desired: null, sent: null, timer: null, inflight: false });
    st.desired = qty;
    drawer.classList.add('nvd-stale');
    clearTimeout(st.timer);
    st.timer = null;
    if (immediate) sendQty(key);
    else st.timer = setTimeout(function () { st.timer = null; sendQty(key); }, 400);
  }

  function sendQty(key) {
    var st = qtyState[key];
    if (!st || st.inflight) return;
    var qty = st.desired;
    var html = null;
    st.inflight = true;
    st.sent = qty;
    nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) {
            qtyFailed = true;
            showMessage(errorText(data, 'Antalet kunde inte ändras. Försök igen.'));
            if (!st.timer) st.desired = st.sent; // sluta försöka med ett antal som inte går, om inget nytt klick väntar
            return;
          }
          if (data && data.sections && typeof data.sections[SECTION] === 'string') html = data.sections[SECTION];
          // Shopify sänker antalet tyst när lagret inte räcker
          if (qty > 0 && data && data.items) {
            var line = null;
            for (var i = 0; i < data.items.length; i++) {
              if (data.items[i].key === key) { line = data.items[i]; break; }
            }
            if (line && line.quantity < qty) {
              showMessage('Vi har tyvärr bara ' + line.quantity + ' st av ' + lineName(line) + ' i lager just nu.');
              st.desired = line.quantity;
              st.sent = line.quantity;
            }
          }
        });
      }, function () {
        qtyFailed = true;
        showMessage('Antalet kunde inte ändras. Kontrollera anslutningen och försök igen.');
        if (!st.timer) st.desired = st.sent;
      })
      .then(function () {
        st.inflight = false;
        if (st.desired !== st.sent && !st.timer) { sendQty(key); return; }
        if (!st.timer) delete qtyState[key];
        if (qtyBusy()) return;
        if (refreshRunning || !html) { refresh(); return; }
        applyHtml(html);
        drawer.classList.remove('nvd-stale');
      });
  }

  inner.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.nvd-qty-btn');
    if (qtyBtn) {
      var key   = qtyBtn.dataset.itemKey;
      var delta = parseInt(qtyBtn.dataset.delta, 10) || 0;
      var valEl = qtyBtn.parentElement.querySelector('.nvd-qty-val');
      var st    = qtyState[key];
      var current = (st && st.desired !== null) ? st.desired : parseInt(valEl ? valEl.textContent : '1', 10) || 1;
      var newQty  = Math.max(0, current + delta);
      if (newQty === 0) {
        confirmRemove(qtyBtn).then(function (ok) {
          if (!ok) return;
          hideMessage();
          var row = qtyBtn.closest('.nvd-item');
          if (row) row.style.opacity = '0.4';
          setQty(key, 0, true);
        });
        return;
      }
      hideMessage();
      if (valEl) valEl.textContent = newQty;
      setQty(key, newQty, false);
      return;
    }
    var removeBtn = e.target.closest('.nvd-item-remove');
    if (removeBtn) {
      var removeKey = removeBtn.dataset.itemKey;
      confirmRemove(removeBtn).then(function (ok) {
        if (!ok) return;
        hideMessage();
        var row = removeBtn.closest('.nvd-item');
        if (row) row.style.opacity = '0.4';
        setQty(removeKey, 0, true);
      });
      return;
    }
  });

  /* ---- Kommentar till ordern (cart.note), delas av lådan och varukorgssidan ---- */
  var NVCartNote = (function () {
    var timer = null;
    var saving = null;
    var dirty = false;
    var lastValue = null;

    // Fältet kan ha ritats om medan sparningen pågick: skriv statusen i det som finns nu
    function currentField(el) {
      if (el && document.contains(el)) return el;
      var again = el && el.id ? document.getElementById(el.id) : null;
      return again || document.querySelector('[data-nv-cart-note]');
    }

    function setStatus(el, text) {
      el = currentField(el);
      var wrap = el && el.closest('[data-nv-cart-note-wrap]');
      var status = wrap && wrap.querySelector('[data-nv-cart-note-status]');
      if (status) status.textContent = text;
    }

    // Sparningar körs i tur och ordning, så att den senaste texten alltid
    // är den som hamnar på ordern även om kunden skriver medan en sparning pågår.
    // Misslyckas den senaste sparningen försöker flush() igen.
    function save(el) {
      clearTimeout(timer);
      timer = null;
      if (!el) return saving || Promise.resolve();
      var value = el.value;
      if (value === lastValue && !dirty) return saving || Promise.resolve();
      dirty = false;
      lastValue = value;
      setStatus(el, 'Sparar…');
      function failed() {
        if (saving !== p) return;
        setStatus(el, 'Kunde inte spara');
        lastValue = null;
        dirty = true;
      }
      var p = (saving || Promise.resolve()).then(function () {
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ note: value })
        }).then(function (r) {
          if (!r.ok) { failed(); return; }
          if (saving === p) setStatus(el, 'Sparad');
        });
      }).catch(failed).then(function () {
        if (saving === p) saving = null;
      });
      saving = p;
      return p;
    }

    document.addEventListener('input', function (e) {
      var el = e.target.closest && e.target.closest('[data-nv-cart-note]');
      if (!el) return;
      dirty = true;
      setStatus(el, '');
      clearTimeout(timer);
      timer = setTimeout(function () { save(el); }, 700);
    });
    document.addEventListener('focusout', function (e) {
      var el = e.target.closest && e.target.closest('[data-nv-cart-note]');
      if (el && (dirty || timer)) save(el);
    });

    return {
      pending: function () { return !!(timer || saving || dirty); },
      flush: function () {
        var el = document.querySelector('[data-nv-cart-note]');
        if (timer || dirty) return save(el);
        return saving || Promise.resolve();
      }
    };
  })();
  window.NVCartNote = NVCartNote;

  /* ---- Kassaknapparna i lådan: spara antal och kommentar först ----
     Svarar true när alla antal är sparade, false vid fel eller efter cirka 4 s. */
  function waitForQty() {
    return new Promise(function (resolve) {
      qtyFailed = false;
      for (var k in qtyState) {
        if (qtyState.hasOwnProperty(k) && qtyState[k].timer) {
          clearTimeout(qtyState[k].timer);
          qtyState[k].timer = null;
          sendQty(k);
        }
      }
      var tries = 0;
      (function check() {
        if (!qtyBusy()) return resolve(!qtyFailed);
        if (tries++ > 40) return resolve(false);
        setTimeout(check, 100);
      })();
    });
  }

  function restoreCheckout(link) {
    if (typeof link.__nvLabel === 'string') link.textContent = link.__nvLabel;
    link.__nvLabel = null;
    link.removeAttribute('aria-busy');
  }
  function restoreAllCheckout() {
    var links = document.querySelectorAll('[data-nv-checkout]');
    for (var i = 0; i < links.length; i++) restoreCheckout(links[i]);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-nv-checkout]');
    if (!link) return;
    // Direkt respons medan kassan laddar, så att klicket inte känns dött
    // (inte vid Ctrl/Cmd-klick, då öppnas kassan i en ny flik)
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if (link.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    if (typeof link.__nvLabel !== 'string') link.__nvLabel = link.textContent;
    link.textContent = 'Går till kassan…';
    if (!qtyBusy() && !NVCartNote.pending()) return;
    e.preventDefault();
    link.setAttribute('aria-busy', 'true');
    Promise.all([waitForQty(), NVCartNote.flush()]).then(function (res) {
      if (!res[0]) {
        // Kunden stannar i lådan och ser vad som hände i stället för att gå vidare med fel antal
        restoreCheckout(link);
        if (!msgEl || msgEl.hidden) showMessage('Några ändringar i varukorgen sparades inte. Kontrollera antalen och försök igen.');
        return;
      }
      window.location.href = link.getAttribute('href') || '/checkout';
    });
  });
  // Tillbaka från kassan (bakåt-cachen) eller sidan lämnas: kassaknapparna visar sin vanliga text igen
  window.addEventListener('pageshow', restoreAllCheckout);
  window.addEventListener('pagehide', restoreAllCheckout);

  /* ---- Intercept add-to-cart ---- */
  /* 1. Form submit
     Ett tillägg i taget per formulär: medan anropet pågår är köpknappen
     upptagen (aria-busy, disabled, texten "Lägger i varukorgen…") och nya
     submit ignoreras, tills svaret kommit (lyckat eller fel). När det är
     klart skickas nv:cart-add {detail: {form, ok}} (den fasta köpraden
     släpper då sin knapp). */
  function submitButton(form, e) {
    var btn = e && e.submitter;
    if (btn && form.contains(btn)) return btn;
    return form.querySelector('button[type="submit"], input[type="submit"]');
  }
  function setAdding(btn, on) {
    if (!btn) return;
    var label = btn.tagName === 'INPUT' ? null : (btn.querySelector('span') || btn);
    if (on) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      if (label) {
        btn.__nvLabel = label.textContent;
        label.textContent = 'Lägger i varukorgen…';
      } else {
        btn.__nvLabel = btn.value;
        btn.value = 'Lägger i varukorgen…';
      }
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (typeof btn.__nvLabel === 'string') {
        if (label) label.textContent = btn.__nvLabel;
        else btn.value = btn.__nvLabel;
      }
      btn.__nvLabel = null;
    }
  }
  document.addEventListener('submit', function (e) {
    if (isCartPage) return;
    var form = e.target;
    var action = form && form.getAttribute ? (form.getAttribute('action') || '') : '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Pågår redan ett tillägg från formuläret: ignorera (dubbelklick)
    if (form.__nvAdding) return;
    form.__nvAdding = true;
    var formData = new FormData(form);
    formData.append('sections', SECTION);
    var btn = submitButton(form, e);
    var ok = false;
    var html = null;
    hideMessage();
    if (currentCount() > 0) updateTop(currentCount());
    // Lådan öppnas (och sparar vart fokus ska tillbaka) innan knappen blir upptagen
    open();
    setAdding(btn, true);
    if (!inner.firstElementChild || inner.querySelector('.nvd-empty')) {
      inner.innerHTML = '<div class="nvd-loading">Lägger till…</div>';
    }
    nativeFetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (r.ok) {
            ok = true;
            if (data && data.sections && typeof data.sections[SECTION] === 'string') html = data.sections[SECTION];
            // Clarity (okt 2026): döda klick på lådans huvud medan kassaknappen
            // väntade på omladdningen. Varan är tillagd, så knappen visas direkt.
            updateTop(1);
            return;
          }
          showMessage(errorText(data, 'Produkten kunde inte läggas till i varukorgen.'));
        });
      }, function () {
        showMessage('Produkten kunde inte läggas till. Kontrollera anslutningen och försök igen.');
      })
      .then(done, done);
    function done() {
      form.__nvAdding = false;
      setAdding(btn, false);
      document.dispatchEvent(new CustomEvent('nv:cart-add', { detail: { form: form, ok: ok } }));
      if (html && !refreshRunning && !qtyBusy()) applyHtml(html);
      else refresh();
    }
  }, true);

  /* 2. fetch()-patch: andra skript som lägger till via fetch */
  (function () {
    var debounceTimer;
    window.fetch = function (resource, init) {
      var url = typeof resource === 'string' ? resource
              : (resource && resource.url) ? resource.url : '';
      var promise = nativeFetch.apply(null, arguments);
      if (!isCartPage && url.indexOf('/cart/add') !== -1) {
        promise.then(function (response) {
          if (response && response.ok) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(openAndRefresh, 80);
          }
        }, function () {});
      }
      return promise;
    };
  })();

  /* 3. XHR-patch: en lyssnare per XHR-objekt, adressen från senaste open() avgör */
  (function () {
    var _open = XMLHttpRequest.prototype.open;
    function onLoad() {
      if (this.__nvCartAdd && this.status >= 200 && this.status < 300) openAndRefresh();
    }
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__nvCartAdd = !isCartPage && typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      if (this.__nvCartAdd && !this.__nvCartListen) {
        this.__nvCartListen = true;
        this.addEventListener('load', onLoad);
      }
      return _open.apply(this, arguments);
    };
  })();

  /* ---- Publikt API ----
     fetch: ursprunglig fetch utan patchen, för anrop som inte ska öppna lådan
     (offerten flyttar produkter till varukorgen). */
  window.NVCartDrawer = {
    open:    openAndRefresh,
    close:   close,
    refresh: refresh,
    updateHeaderCount: updateHeaderCount,
    fetch:   nativeFetch
  };
})();
